import { render } from "./JobDetail.vue?vue&type=template&id=ad6fc894&scoped=true"
import script from "./JobDetail.vue?vue&type=script&lang=js"
export * from "./JobDetail.vue?vue&type=script&lang=js"

import "./JobDetail.vue?vue&type=style&index=0&id=ad6fc894&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad6fc894"]])

export default __exports__